import React from 'react';
import { ArrowLeft } from 'lucide-react';
interface ImpressumPageProps {
  onBack: () => void;
}
export function ImpressumPage({
  onBack
}: ImpressumPageProps) {
  return <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8" data-id="element-479">
      <div className="max-w-3xl mx-auto" data-id="element-480">
        <button onClick={onBack} className="flex items-center text-slate-500 hover:text-brand-500 transition-colors mb-8 group" data-id="element-481">
          <ArrowLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-482" />
          Zurück zur Startseite
        </button>

        <h1 className="text-3xl md:text-4xl font-serif font-bold text-slate-900 mb-8" data-id="element-483">
          Impressum
        </h1>

        <div className="prose prose-slate max-w-none text-slate-600" data-id="element-484">
          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-485">
            Angaben gemäß § 5 TMG
          </h2>
          <p data-id="element-486">
            Nuviora UG (haftungsbeschränkt) Cosimastraße 121 München, 81925
            Deutschland
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-487">
            Vertreten durch
          </h2>
          <p data-id="element-488">Geschäftsführer: Khoanh Nam Ta</p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-489">
            Kontakt
          </h2>
          <p data-id="element-490">E-Mail: support@uronacht.de</p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-491">
            Registereintrag
          </h2>
          <p data-id="element-492">
            Eintragung im Handelsregister. Handelsregister: HRB 306058
            Registergericht: Amtsgericht München
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-493">
            Umsatzsteuer-ID
          </h2>
          <p data-id="element-494">
            Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:
            DE457899389
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-495"></h2>
          <p data-id="element-496"></p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-497">
            EU-Streitschlichtung
          </h2>
          <p data-id="element-498">
            Die Europäische Kommission stellt eine Plattform zur
            Online-Streitbeilegung (OS) bereit:
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-brand-500 hover:underline ml-1" data-id="element-499">
              https://ec.europa.eu/consumers/odr/
            </a>
            .<br data-id="element-500" />
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-501">
            Verbraucherstreitbeilegung/Universalschlichtungsstelle
          </h2>
          <p data-id="element-502">
            Wir sind nicht bereit oder verpflichtet, an
            Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
            teilzunehmen.
          </p>
        </div>
      </div>
    </div>;
}